import { ZudokuPlugin } from "zudoku";
import React from "react";

const siteId = 5359436;
const hotjarVersion = 6;

const HotjarPlugin: ZudokuPlugin = {
  getHead: () => (
    <script>
      {`(function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${siteId},hjsv:${hotjarVersion}};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
    </script>
  ),
};

export default HotjarPlugin;
